import * as React from 'react';
import { palette } from '../../constants';
import { Checkbox } from '../Checkbox';
import { Badge } from '../Badge';
import { FillContainer, ContentButton, IconContainer } from './ActionItem.styles';
export var ActionItemFill = React.memo(function (props) {
    var name = props.name, value = props.value, fillValue = props.fillValue, badgeCount = props.badgeCount, onClick = props.onClick, onChange = props.onChange;
    var _a = React.useState(props.checked), checked = _a[0], setChecked = _a[1];
    var handleChange = React.useCallback(function handleChange(e) {
        setChecked(e.currentTarget.checked);
        if (onChange !== undefined) {
            onChange(e);
        }
    }, []);
    return (React.createElement(FillContainer, { isChecked: checked, fillWidth: fillValue !== null && fillValue !== void 0 ? fillValue : 0 },
        React.createElement(IconContainer, null,
            React.createElement(Checkbox, { name: name !== null && name !== void 0 ? name : '', value: value !== null && value !== void 0 ? value : '', checked: checked, onChange: handleChange })),
        React.createElement(ContentButton, { onClick: onClick }, props.children),
        badgeCount !== undefined && (React.createElement(IconContainer, { right: true },
            React.createElement(Badge, { backgroundColor: palette.blue6, foregroundColor: palette.neutral1 }, badgeCount)))));
}, function (p, n) {
    return p.checked === n.checked &&
        p.badgeCount === n.badgeCount &&
        p.fillValue === n.fillValue;
});
ActionItemFill.displayName = 'ActionItemFill';
//# sourceMappingURL=ActionItemFill.js.map